<template>
  <div>
    <div class="section-summary-row">
      <span>{{ deliveryMethod.methodLabel }}</span>
      <span class="method-price">{{
        deliveryOption ? deliveryOption.price : deliveryMethod.price
      }}</span>
    </div>

    <div v-if="disableEditMode || (showDeliveryAddress && deliveryAddress)" class="section-summary-row">
      <span>{{ deliveryAddress.firstName }} {{ deliveryAddress.lastName }}</span>
      <span v-html="formatedAddress" />
    </div>

    <div v-if="showDeliveryTemporaryAddressUS && deliveryTemporaryAddressUS" class="section-summary-row">
      <span>{{ deliveryTemporaryAddressUS.firstName }} {{ deliveryTemporaryAddressUS.lastName }}</span>
      <span v-html="formatedTemporaryAddressUS" />
    </div>

    <component
        v-bind:is="summaryType"
        :deliveryOption="deliveryOption"
        :title="deliveryMethod.previewTitle"
     />

  </div>
</template>
<script src="./delivery-summary.js"/>
